module.exports = __webpack_public_path__ + "static/media/1018433.2ffd40b5.png";